import { Routes } from '@angular/router';
import { PublicComponent } from './components/public/public';
import { PersonasComponent } from './components/personas/personas';
import { ConfrontoComponent } from './components/confronto/confronto';
import { LoginComponent } from './components/login/login.component';
import { PasswordRecoveryComponent } from './components/password-recovery/password-recovery.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { AuthGuard } from './guards/auth.guard';
import { AudienceCreateExitGuard } from './guards/audience-create-exit.guard';
import { AudienceComponent } from './components/audience/audience';
import { CustomImportsComponent } from './components/custom-imports/custom-imports.component';
import { DestinationsComponent } from './components/destinations/destinations.component';
import { GoalsComponent } from './components/goals/goals.component';
import { HomeComponent } from './components/home/home.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RealtimeComponent } from './components/realtime/realtime.component';
import { DocumentationComponent } from './components/documentation/documentation.component';
import { TrackingScriptsComponent } from './components/tracking-scripts/tracking-scripts.component';
import { CmpComponent } from './components/cmp/cmp.component';
import { ReportsProviderComponent } from './components/reports/provider/reports-provider.component';
import { ReportsConsumerComponent } from './components/reports/consumer/reports-consumer.component';
import { NotificationsPageComponent } from './components/notifications-page/notifications-page.component';
import { UserPermissions } from './services/permissions';

export const routes: Routes = [
  // `publicPage: true` = nessuna sidebar e nessun redirect al login (vedi App.isPublicPage).
  { path: 'login', component: LoginComponent, data: { publicPage: true } },
  { path: 'password-recovery', component: PasswordRecoveryComponent, data: { publicPage: true } },
  // Ci arriva chiunque riceva il link di reset via email, anche senza accesso alla Console.
  { path: 'password-reset', component: PasswordResetComponent, data: { publicPage: true } },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'documentation',
    component: DocumentationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'notifications',
    component: NotificationsPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard/realtime',
    component: RealtimeComponent,
    canActivate: [AuthGuard],
    // analytics.all (and all) imply analytics.realtime through the permission tree.
    data: { requiredPermissions: [UserPermissions.ANALYTICS_REALTIME] }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    // analytics.all (and all) imply analytics.overview through the permission tree.
    data: { requiredPermissions: [UserPermissions.ANALYTICS_OVERVIEW] }
  },
  {
    path: 'vision',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { requireVisionDcr: true },
    children: [
      { path: 'public', component: PublicComponent, data: { requiredPermissions: [UserPermissions.VISION] } },
      { path: 'personas', component: PersonasComponent, data: { requiredPermissions: [UserPermissions.VISION] } },
      { path: 'comparison', component: ConfrontoComponent, data: { requiredPermissions: [UserPermissions.VISION] } },
      { path: '', redirectTo: 'public', pathMatch: 'full' }
    ]
  },
  {
    path: 'reach',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'audiences',
        component: AudienceComponent,
        data: { requiredPermissions: [UserPermissions.REACH_AUDIENCE] },
        canDeactivate: [AudienceCreateExitGuard]
      },
      { path: 'custom-imports', component: CustomImportsComponent, data: { requiredPermissions: [UserPermissions.REACH_AUDIENCE] } },
      { path: 'destinations', component: DestinationsComponent, data: { requiredPermissions: [UserPermissions.ADMIN_DASHBOARD] } },
      { path: 'goals', component: GoalsComponent, data: { requiredPermissions: [UserPermissions.REACH_AUDIENCE] } },
      {
        path: 'reports',
        canActivate: [AuthGuard],
        data: { requiredPermissions: [UserPermissions.REACH_REPORTING] },
        children: [
          { path: 'provider', component: ReportsProviderComponent },
          { path: 'consumer', component: ReportsConsumerComponent },
          { path: '', redirectTo: 'provider', pathMatch: 'full' }
        ]
      },
      { path: '', redirectTo: 'audiences', pathMatch: 'full' }
    ]
  },
  {
    path: 'tracking-scripts',
    canActivate: [AuthGuard],
    data: { strictPermissions: [UserPermissions.SCRIPTS] },
    children: [
      { path: 'configs', component: TrackingScriptsComponent },
      { path: '', redirectTo: 'configs', pathMatch: 'full' }
    ]
  },
  {
    path: 'cmp',
    canActivate: [AuthGuard],
    data: { strictPermissions: [UserPermissions.CMP] },
    children: [
      { path: 'configs', component: CmpComponent },
      { path: '', redirectTo: 'configs', pathMatch: 'full' }
    ]
  },
  // `/console/*` NON e' piu' una rotta di questa app: la Console e' un deploy a se' (repo
  // tncid-app-console, servizio Cloud Run tncid-console*) e il load balancer instrada /console e
  // /console/* la' prima che la richiesta arrivi qui. La voce di menu nella sidebar e' quindi una
  // navigazione esterna (window.location), non un routerLink.
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home' }
];
